import { render, staticRenderFns } from "./ObjectAttachments.vue?vue&type=template&id=dd563930&"
import script from "./ObjectAttachments.vue?vue&type=script&lang=js&"
export * from "./ObjectAttachments.vue?vue&type=script&lang=js&"
import style0 from "./ObjectAttachments.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports